var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ds-control ds-no-padding ds-design-img dsf-image",
      style: { "text-align": _vm.align },
    },
    [
      _vm.src
        ? [
            _c("el-image", {
              style: _vm.sizeStyle,
              attrs: {
                src: _vm.$src,
                fit: _vm.fit,
                alt: _vm.alt,
                "referrer-policy": _vm.referrerPolicy,
                lazy: _vm.lazy,
                "scroll-container": _vm.scrollContainer,
                "preview-src-list": _vm.previewSrcList,
                "z-index": _vm.zIndex,
              },
              on: {
                load: function ($event) {
                  return _vm.$emit("load", $event)
                },
                error: function ($event) {
                  return _vm.$emit("error", $event)
                },
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "placeholder",
                    fn: function () {
                      return [
                        _vm._t("placeholder", function () {
                          return [_c("i", { staticClass: "el-icon-loading" })]
                        }),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "error",
                    fn: function () {
                      return [
                        _vm._t("error", function () {
                          return [
                            _vm.failDataObj
                              ? [
                                  _vm.failDataObj.isImage
                                    ? _c("img", {
                                        staticClass: "dsf-image-fail",
                                        attrs: {
                                          src: _vm.failDataObj.value,
                                          alt: "加载异常",
                                        },
                                      })
                                    : _c("span", {
                                        staticClass: "dsf-image-fail",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.failDataObj.value
                                          ),
                                        },
                                      }),
                                ]
                              : _vm._e(),
                          ]
                        }),
                      ]
                    },
                    proxy: true,
                  },
                ],
                null,
                true
              ),
            }),
          ]
        : [
            _vm._t("empty", function () {
              return [
                _vm.emptyDataObj
                  ? [
                      _vm.emptyDataObj.isImage
                        ? _c("img", {
                            staticClass: "dsf-image-empty",
                            attrs: {
                              alt: "图片缺失",
                              src: _vm.emptyDataObj.value,
                            },
                          })
                        : _c("span", {
                            staticClass: "dsf-image-empty",
                            domProps: {
                              innerHTML: _vm._s(_vm.emptyDataObj.value),
                            },
                          }),
                    ]
                  : _vm._e(),
              ]
            }),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }